// extracted by mini-css-extract-plugin
export default {"icon-button":"icon-button--plj68","iconButton":"icon-button--plj68","icon":"icon--s8p8W"};